import React from "react";

const hobbies = [
  {
    title: "Digital Storyteller",
    description: "Writing tech blogs and making YouTube videos to share what I learn.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
        <rect x="3" y="6" width="12" height="12" rx="2" />
        <path d="M15 10l6 -3v10l-6 -3" />
      </svg>
    ),
  },
  {
    title: "Music Enthusiast",
    description: "Every genre, no skips — always exploring something new to listen to.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
        <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
        <rect x="2" y="14" width="4" height="6" rx="1.5" />
        <rect x="18" y="14" width="4" height="6" rx="1.5" />
      </svg>
    ),
  },
  {
    title: "Rhythm Keeper",
    description: "Playing tabla and dholak — India's classic percussion duo.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
        <ellipse cx="12" cy="7" rx="8" ry="3" />
        <path d="M4 7v8a8 3 0 0 0 16 0v-8" />
        <path d="M8 10v3" />
        <path d="M16 10v3" />
      </svg>
    ),
  },
  {
    title: "Wanderlust",
    description: "Always planning the next trip — exploring new places keeps me energized.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
        <circle cx="12" cy="12" r="9" />
        <path d="M14.5 9.5l-1.5 5l-5 1.5l1.5 -5z" />
      </svg>
    ),
  },
];

export default function BeyondTheCode() {
  return (
    <section>
      <h2 className="text-3xl font-bold text-white mb-6">Beyond the Code</h2>

      <div className="flex flex-wrap gap-5">
        {hobbies.map((hobby) => (
          <div
            key={hobby.title}
            className="w-[calc(50%-10px)] sm:w-full bg-[#252A30] border border-white/5 rounded-xl p-5 flex flex-col"
          >
            <div className="text-green-400 mb-3">{hobby.icon}</div>
            <h3 className="text-white font-semibold text-lg mb-1">{hobby.title}</h3>
            <p className="text-gray-400 text-sm">{hobby.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
